import React from 'react'
import { Button, Confirm, Header, Form, Icon, input } from 'semantic-ui-react'
import { inlineStyle } from '../../styles/custom'

const ArticleLinkForm = ({ obj, detail, status, onChange, onSubmit, onDelete }) => {
  return (
    <Form>
      <Header as="h1">{status.isNew ? 'Nouveau l' : 'L'}ien {obj.text ? ' : '+obj.text : null}</Header>
      <Form.Field>
        <label>Libellé</label>
        <input placeholder="Libellé" id="text" value={obj.text} onChange={onChange} />
      </Form.Field>
      <Form.Field>
        <label>Adresse</label>
        <input placeholder="Adresse" id="url" value={obj.url} onChange={onChange} />
      </Form.Field>
      <Form.Field>
        {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
          <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
        }
        {!status.isNew ? (
          <div>
            <Button type='submit' color='red' floated='right' onClick={(event, data) => { onDelete(event, { confirm: true }) }}><Icon name="delete" /> Suppression</Button>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content='Êtes-vous sûr(e) de vouloir supprimer ce lien ? Cette action est définitive.'
        open={status.deletion.confirm} onCancel={(event, data) => { onDelete(event, { confirm: null }) }}
        onConfirm={(event, data) => { onDelete(event, { confirm: false }) }}
        style={inlineStyle.modal}
        cancelButton='Annuler'
        confirmButton='Ok'
      />
    </Form>
  )
}

export default ArticleLinkForm



// WEBPACK FOOTER //
// ./src/components/form/ArticleLink.js